export default "//file.bilionpass.com/japandx-web/0.0.1/static/custom.45ef4e0e-c81731.svg";